import { logError } from "./log-error";

import type { Result } from "../index";


export const STRICT_US_STATES_CODES = ["MD"];
export const STRICT_US_STATES = ["Maryland"];

export type GeoDataResponse = {
  continent: { code: string };
  country: { isoCode: string };
  subdivisions: [{ isoCode: string }];
};

export const fetchGeoData = async (): Promise<Result<GeoDataResponse>> => {
  const BASE_URL = process.env["NEXT_PUBLIC_HALL_OF_RECORDS_URI"] as string;
  const ENDPOINT = `${BASE_URL}/v2/c/lc/where-am-i`;

  try {
    const response = await fetch(ENDPOINT);
    const json: GeoDataResponse = await response.json();
    return { value: json, error: null };
  } catch (error) {
    logError({ action: "FETCH_GEO_DATA", error });
    return { value: null, error: error as Error };
  }
};
